define.alias("shared/helpers/rebase-indexed-number", "media/helpers/rebase-indexed-number");